import { markRaw } from 'vue';

import { TTableColumnConfig } from '@/common/components/redesigned/Table/types/tableTypes';
import { getRuFormattedRangeDateWithMonthWord } from '@/common/utils/dates';

import { TDashboardsTableItem } from '../../types/dashboards';
import EventsVESTableActionsCell from '../EventsVESTableActionsCell.vue';

const COLUMN_WIDTH = 168;

export const subjectColumn: TTableColumnConfig<TDashboardsTableItem> = {
  field: 'organizer',
  title: 'Субъект РФ',
  width: COLUMN_WIDTH,
};

export const actionsColumn: TTableColumnConfig<TDashboardsTableItem> = {
  field: 'isSystemEvent',
  title: '',
  width: 56,
  renderComponent: {
    component: markRaw(EventsVESTableActionsCell),
  },
};

export const datesColumn: TTableColumnConfig<TDashboardsTableItem> = {
  field: 'startEventDate',
  title: 'Даты проведения',
  width: COLUMN_WIDTH,
  sortable: true,
  formatter: (item) => getRuFormattedRangeDateWithMonthWord(item.startEventDate, item.endEventDate, true),
};

const CLARIFIED_TEXT = 'Уточняется';

const getPartnerCountryText = (item: TDashboardsTableItem): string => {
  const partnerCountry = item.partnerCountry;
  if (!Array.isArray(partnerCountry) || !partnerCountry.length) return '';
  return partnerCountry.map((pc) => pc.name).join(', ');
};

const partnerCountryColumn: TTableColumnConfig<TDashboardsTableItem> = {
  field: 'partnerCountry',
  title: 'Страна-партнер',
  width: COLUMN_WIDTH,
  formatter: getPartnerCountryText,
};

const ministryPartnerCountryColumn: TTableColumnConfig<TDashboardsTableItem> = {
  ...partnerCountryColumn,
  formatter: (item) => getPartnerCountryText(item) || CLARIFIED_TEXT,
};

const commonEventColumns: TTableColumnConfig<TDashboardsTableItem>[] = [
  {
    field: 'eventType',
    title: 'Вид мероприятия',
    width: COLUMN_WIDTH,
  },
  datesColumn,
  {
    field: 'eventLocation',
    title: 'Место',
    width: COLUMN_WIDTH,
  },
  {
    field: 'name',
    title: 'Наименование',
    width: COLUMN_WIDTH,
    formatter: (item) => item.name || item.description || '',
  },
  {
    field: 'eventStatus',
    title: 'Статус',
    width: COLUMN_WIDTH,
  },
];

export const baseEventColumns: TTableColumnConfig<TDashboardsTableItem>[] = [
  partnerCountryColumn,
  ...commonEventColumns,
];

export const ministryEventColumns: TTableColumnConfig<TDashboardsTableItem>[] = [
  ministryPartnerCountryColumn,
  ...commonEventColumns,
];

export const getPlannedEventColumns = (isDatesColumnFirst = false): TTableColumnConfig<TDashboardsTableItem>[] => {
  const columns = [subjectColumn, ...baseEventColumns];

  return isDatesColumnFirst ? [datesColumn, ...columns.filter((column) => column !== datesColumn)] : columns;
};
